module.exports = __webpack_public_path__ + "img/降雨量.ad428cd0.png";